import { createFileRoute } from '@tanstack/react-router';
import type { ReactNode } from 'react';
import { FlightCheckDashboard } from '../../../components/flight-check/FlightCheckDashboard.js';
import { FlightCheckPage } from '../../../components/flight-check/FlightCheckPage.js';
import { DASHBOARD_MOCK } from '../../../components/flight-check/flightCheckMocks.js';

// Hidden: no nav item links here until the Flight Check backend lands.
function FlightCheckDashboardRoute(): ReactNode {
  return (
    <FlightCheckPage title="Dashboard" subtitle="How your creatives score before they go live.">
      <FlightCheckDashboard data={DASHBOARD_MOCK} />
    </FlightCheckPage>
  );
}

export const Route = createFileRoute('/flight-check/dashboard/')({
  component: FlightCheckDashboardRoute,
});
